
import { xyz_n_1of4, insertInto } from './SL00000Sprint00TTR'

import { list49200Sprint06 } from '../ActivityLists/AL49200Sprint06'
import { list49200Sprint07 } from '../ActivityLists/AL49200Sprint07'

import { basicSlide, orderedListSlide } from './SLSprint00'

// Software Systems Capstone (SSC) sprint 7 global values.
const sprint = 7
const activityList = () => { return list49200Sprint07(sprint) }
const activityListPrevious = () => { return list49200Sprint06(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
const ssc_7_1of4 = () => {
	const sprintPlanningExpectations = () => {
		return orderedListSlide('Sprint Planning', `Sprint ${sprint} Expectations:`, [
			'Similar to other sprints with a Discussion, Lab, and Reflection',
			'Similar in that all classes are in-person synchronous',
			`Similar in that we will have 2 weeks to complete all sprint ${sprint} activities and assignments`,
			`Different in that Lab ${sprint} - Planning will be due by the end of the day Thursday`
		 ])
	}
	const activitiesReviewSprint8 = () => {
		return basicSlide('Sprint 8 Activity List and Assignments Review', [
			'Let’s open our Blackboard shell and review the Sprint 8 activity list and assignments together.' ])
	}

	const slideDeck = xyz_n_1of4(null, null, sprintAndActivityLists, sprintPlanningExpectations)
	const insertAfterActivitiesReview = 6
	return insertInto(slideDeck, activitiesReviewSprint8, insertAfterActivitiesReview)
}

export const ssc_7_slidedeckTTR = [ ssc_7_1of4, null, null, null ]